/* ==========================================
   GRAND SLAM COLLECTIBLES
   Custom Header JavaScript
   ========================================== */

(() => {
  function initGSCHeader(header) {
    if (header.dataset.gscInitialized === 'true') return;

    header.dataset.gscInitialized = 'true';

    // Sticky header behavior
const announcement = header.querySelector(
  '.gsc-header__announcement'
);

let stickyPlaceholder = null;

function updateStickyHeader() {
  if (window.scrollY > 80) {
    header.classList.add('is-sticky');
  } else {
    header.classList.remove('is-sticky');
  }
}

window.addEventListener('scroll', updateStickyHeader, {
  passive: true
});

updateStickyHeader();

    const openButton = header.querySelector('[data-gsc-menu-open]');
    const closeButton = header.querySelector('[data-gsc-menu-close]');
    const drawer = header.querySelector('.gsc-header__drawer');
    const overlay = header.querySelector('[data-gsc-overlay]');

    if (!openButton || !drawer || !overlay) return;

    let previousFocus = null;

    function openDrawer() {
      previousFocus = document.activeElement;

      drawer.hidden = false;
      overlay.hidden = false;

      openButton.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';

      if (closeButton) {
        closeButton.focus();
      }
    }

    function closeDrawer() {
      drawer.hidden = true;
      overlay.hidden = true;

      openButton.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';

      if (previousFocus && typeof previousFocus.focus === 'function') {
        previousFocus.focus();
      } else {
        openButton.focus();
      }
    }

    openButton.addEventListener('click', openDrawer);

    if (closeButton) {
      closeButton.addEventListener('click', closeDrawer);
    }

    overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !drawer.hidden) {
        closeDrawer();
      }
    });

    // Close the drawer after a navigation link is selected.
    drawer.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        closeDrawer();
      });
    });

    // If the viewport changes to desktop, close the mobile drawer.
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 750 && !drawer.hidden) {
        closeDrawer();
      }
    });
  }

  function initAllGSCHeaders() {
    document.querySelectorAll('.gsc-header').forEach(initGSCHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllGSCHeaders);
  } else {
    initAllGSCHeaders();
  }

  // Support Shopify theme editor section reloads.
  document.addEventListener('shopify:section:load', (event) => {
    const header = event.target.querySelector('.gsc-header');

    if (header) {
      header.dataset.gscInitialized = 'false';
      initGSCHeader(header);
    }
  });
})();